import {
  CARD_STATUS_ACTIVE,
  CARD_STATUS_OFF,
  CARD_STATUS_TEMPORARY_BLOCKED,
  CARD_TYPE_PHYSICAL,
  CARD_TYPE_VIRTUAL,
} from '@/shared/constants/card';

export function isCardOff(status: number): boolean {
  return status === CARD_STATUS_OFF || status === CARD_STATUS_TEMPORARY_BLOCKED;
}

export function isCardActive(status: number): boolean {
  return status === CARD_STATUS_ACTIVE;
}

export function showCardOffBanner(status: number) {
  if (status === undefined) {
    return false;
  }
  return isCardOff(status);
}

export function isCardPhysical(type: number): boolean {
  return type === CARD_TYPE_PHYSICAL;
}

export function isCardVirtual(type: number): boolean {
  return type === CARD_TYPE_VIRTUAL;
}
